export const GET_TOTAL_STATS = 'RPT/get_total_stats';
export const GET_GRAPH_STATS = 'RPT/get_graph_stats';

  export const STATISTICS = [
    { name: 'LAND', color: '#5272AA', value: 0 },
    { name: 'BUILDING', color: '#8EEED7', value: 0 },
    { name: 'MACHINERY', color: '#D9F5FA', value: 0 },
  ];